var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col rockblue",class:_vm.selected ? 'text-primary' : ''},[_c('span',{staticClass:"status-label"},[_vm._v(_vm._s(_vm.statusLabel))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"status-verb"},[_vm._v(_vm._s(_vm.statusVerb))])])
}
var staticRenderFns = []

export { render, staticRenderFns }